"use strict";
var Shopify = Shopify || {},
  AddToCartView = Backbone.View.extend({
    initialize: function(t) {
      console.log("init addtocart module ..."), this.productJSON = t.productJSON, this.prefix = t.prefix, void 0 !== this.productJSON && (this.watchVariantStock(), this.initImages(), this.initOptionSelectors())
    },
    initOptionSelectors: function() {
      function t(t) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
        this.product = t, this.prefix = i, this.$form = $("".concat(this.prefix, ' form[data-product-id="').concat(this.product.id, '"')), this.$ = this.$form.find.bind(this.$form), this.$id = this.$('select[name="id"]'), this.$finalSale = this.$("input[data-final-sale]"), this.$finalSale.$badge = this.$("span.final_sale"), this.$price = this.$(".variant-price"), this.$quadpayPrice = this.$(".qp-variant-price"), this.$compareAtPrice = this.$(".comparePrice"), this.$promoBadge = this.$(".price-promo"), this.swatches = {
          $colors: this.$('label[aria-label^="Color"] > input'),
          $sizes: this.$('label[aria-label^="Size"] > input')
        }, (this.swatches.$colors.length || this.swatches.$sizes.length) && this.$id.val(""), this.swatches.$colors.$select = this.$(".product-form-bottom .select.colors"), this.swatches.$sizes.$select = this.$(".product-form-bottom .select.sizes"), this.swatches.$colors.name = this.swatches.$colors.attr("name"), this.swatches.$sizes.name = this.swatches.$sizes.attr("name"), this.swatches.$colors.optionIndex = this.product.options.findIndex((function(t) {
          return /color/i.test(t)
        })), this.swatches.$sizes.optionIndex = this.product.options.findIndex((function(t) {
          return /size/i.test(t)
        })), this.sortSwatches();
        var e = this.swatches.$colors.has("input:checked");
        e.length || (e = this.swatches.$colors.first()), e.length || (e = this.swatches.$sizes.first()), e.length && e.get(0).click(), e.closest(".swatch-element").addClass("selected"), this.fitAndFabric = {
          $custom: $("".concat(this.prefix, " #fit-fabric-custom")),
          $regular: $("".concat(this.prefix, " #fit-fabric-regular"))
        }, this.tryTriggerVariantChanged(e.val() || this.$id.val()).watchSwatchInputs().tryAutoselectPlusSizeVariant()
      }
      t.variantSizes = {
        xs: "Extra Small",
        s: "Small",
        m: "Medium",
        l: "Large",
        xl: "Extra Large"
      }, t.prototype.formatFinalSaleBadgeForVariant = function() {
        var t = this.getVariantById().options[this.swatches.$colors.optionIndex];
        return t ? (this.product.tags.map((function(t) {
          return t.toLowerCase()
        })).includes("final_sale") ? (this.$finalSale.$badge.text("#side-cart" === this.prefix ? "Final Sale" : "FINAL SALE: ".concat(this.$finalSale.data("value"))), this.$finalSale.attr("name", this.$finalSale.data("name")).attr("value", this.$finalSale.data("value"))) : (this.$finalSale.$badge.empty(), this.$finalSale.attr("name", null).attr("value", null)), this) : this
      }, t.prototype.formatFitAndFabric = function() {
        var t = this,
          i = this.getVariantById();
        return this.fitAndFabric.$custom.empty().hide(), +i.id != +this.$id.val() ? (this.fitAndFabric.$regular.show(), this) : ($.get("/products/".concat(this.product.handle) + "?view=fit_fabric_variant&variant=".concat(i.id)).done((function(i) {
          (i = i.trim()).length ? (t.fitAndFabric.$regular.hide(), t.fitAndFabric.$custom.html(i).show()) : t.fitAndFabric.$regular.show()
        })), this)
      }, t.prototype.formatSizeSwatchesForColorVariant = function(t) {
        var i = this,
          e = this.getVariantById(t).options[this.swatches.$colors.optionIndex];
        if (!e) return this;
        var s = this.swatches.$sizes.$select.find(".select-option");
        return this.swatches.$sizes.each((function(t, a) {
          var r = $(a).closest(".swatch-element"),
            o = s.eq(t),
            n = i.getVariantByOptions(e, a.title);
          n ? (a.value = n.id, r.show(), o.show(), n.available ? (r.removeClass("soldout"), o.removeClass("soldout")) : (r.addClass("soldout"), o.addClass("soldout"))) : (a.value = "", r.hide(), o.hide(), r.addClass("soldout"), o.addClass("soldout"))
        })), this
      }, t.prototype.formatMoney = function(t) {
        return window.Shopify.formatMoney(t, window.Shopify.money_format).replace(".00", "").replace("$", FORMAT_MONEY_SYMBOL)
      }, t.prototype.formatProductPriceForVariant = function() {
        var t = this,
          i = this.getVariantById(),
          e = i.compare_at_price,
          s = i.options,
          a = i.price;
        if (this.$price.removeClass("red"), this.$quadpayPrice.closest("#quadPayCalculatorWidget").show(), this.$promoBadge.show(), +i.id == +this.$id.val()) return this.$price.html(this.formatMoney(a)), this.$quadpayPrice.html(this.formatMoney(a / 4)), e > a ? (this.$compareAtPrice.html(this.formatMoney(e)), this.$price.addClass("red")) : this.$compareAtPrice.empty(), this;
        var r = s[this.swatches.$colors.optionIndex],
          o = this.product.variants.filter((function(i) {
            return i.options[t.swatches.$colors.optionIndex] === r
          })).map((function(t) {
            return t.price
          })),
          n = Math.min.apply(null, o),
          c = Math.max.apply(null, o);
        return n === c ? (this.$price.html(this.formatMoney(a)), this.$quadpayPrice.html(this.formatMoney(a / 4)), e > a ? (this.$compareAtPrice.html(this.formatMoney(e)), this.$price.addClass("red")) : this.$compareAtPrice.empty()) : (this.$price.html("\n          ".concat(this.formatMoney(n), " &ndash; ").concat(this.formatMoney(c), "\n        ").trim()), this.$quadpayPrice.empty().closest("#quadPayCalculatorWidget").hide(), this.$compareAtPrice.empty()), this
      }, t.prototype.formatSwatchHeadings = function() {
        for (var i = 0, e = ["color", "size"]; i < e.length; i++) {
          var s = e[i],
            a = this.getSelectedOption(s),
            r = this.swatches["$".concat(s, "s")].optionIndex,
            o = a ? this.getVariantById(a.value).options[r] : "";
          o = o.replace(/\w*(?=\/|$)/g, (function(i) {
            return t.variantSizes[i.toLowerCase()] || i
          })), this.$('.swatch[data-option-index="'.concat(r, '"]')).find(".variant-name,.variant-size").text(o)
        }
        return this
      }, t.prototype.getSelectedOption = function(t) {
        var i = this;
        return this.$form.serializeArray().find((function(e) {
          var s = e.name,
            a = e.value;
          return s === i.swatches["$".concat(t, "s")].name && a
        }))
      }, t.prototype.getVariantById = function(t) {
        return t = t || this.getSelectedOption("size") || this.getSelectedOption("color") || this.$id.val(), "object" === _typeof(t) && (t = t.value), this.product.variants.find((function(i) {
          return +i.id == +t
        })) || this.product.variants[0]
      }, t.prototype.getVariantByOptions = function(t, i) {
        var e = this;
        return this.product.variants.find((function(s) {
          var a = s.options;
          return a[e.swatches.$colors.optionIndex] === t && a[e.swatches.$sizes.optionIndex] === i
        }))
      }, t.prototype.sortSwatches = function() {
        var t = ["xs", "s", "m", "l", "xl"].map((function(t) {
            return new RegExp("^".concat(t), "i")
          })).reverse(),
          i = this.swatches.$sizes.closest(".actual-swatches");
        i.children().detach().sort((function(i, e) {
          var s = [i, e].map((function(i) {
            var e = $(i).data("value");
            return /^\d/.test(e) || (e = -t.findIndex((function(t) {
              return t.test(e)
            }))), parseInt(e)
          }));
          return s[0] - s[1]
        })).appendTo(i)
      }, t.prototype.tryAutoselectPlusSizeVariant = function() {
        var t = this;
        if (!this.$form.closest("#product-wrap").is("[data-plus-size-item]")) return this;
        var i = this.product.variants.find((function(i) {
          return i.available && /\dx/i.test(i[t.swatches.$sizes.optionIndex])
        }));
        if (!i) return this;
        var e = i.options[this.swatches.$colors.optionIndex];
        this.swatches.$colors.filter((function(t, i) {
          return i.title === e
        })).click();
        var s = i.options[this.swatches.$sizes.optionIndex];
        return this.swatches.$sizes.filter((function(t, i) {
          return i.title === s
        })).click(), this
      }, t.prototype.tryTriggerVariantChanged = function(t) {
        var i = this.product.variants.find((function(i) {
          return +i.id == +t
        }));
        return i ? (this.formatSizeSwatchesForColorVariant(), this.$form.trigger("variant-changed", [this.product.id, i, !this.swatches.$sizes.length || Boolean(this.getSelectedOption("size"))]), this.$id.val() !== t && this.$id.val(this.swatches.$sizes.length ? this.getSelectedOption("size") ? t : "" : this.getSelectedOption("color").value), this.formatFitAndFabric().tryUpdateSelects().formatSwatchHeadings().formatProductPriceForVariant().formatFinalSaleBadgeForVariant(), this) : this
      }, t.prototype.tryUpdateSelects = function() {
        for (var t = 0, i = ["color", "size"]; t < i.length; t++) {
          var e = i[t],
            s = this.getSelectedOption(e),
            a = this.swatches["$".concat(e, "s")],
            r = a.optionIndex,
            o = a.$select,
            n = s ? this.getVariantById(s.value).options[r] : "";
          o.trigger("select.select", [e, n])
        }
        return this
      }, t.prototype.watchSwatchInputs = function() {
        var t = this;
        return this.swatches.$colors.on("input", (function(i) {
          t.formatSizeSwatchesForColorVariant(i.currentTarget.value);
          var e = t.getSelectedOption("color").value,
            s = t.getSelectedOption("size") ? t.getSelectedOption("size").value : t.swatches.$sizes.filter('[value!=""]').first().val();
          t.tryTriggerVariantChanged(s || e), $(i.currentTarget).closest(".swatch-element").addClass("selected").siblings().removeClass("selected")
        })), this.swatches.$sizes.on("input", (function(i) {
          t.tryTriggerVariantChanged(i.currentTarget.value), $(i.currentTarget).closest(".swatch-element").addClass("selected").siblings().removeClass("selected")
        })), this.swatches.$colors.$select.on("change.select", (function(i, e) {
          t.swatches.$colors.filter('[title="'.concat(e, '"]')).click()
        })), this.swatches.$sizes.$select.on("change.select", (function(i, e) {
          t.swatches.$sizes.filter('[title="'.concat(e, '"]')).click()
        })), this.$id.on("change", (function(i) {
          t.tryTriggerVariantChanged(i.currentTarget.value)
        })), this
      }, this.optionSelectors = new t(this.productJSON, this.prefix)
    },
    watchVariantStock: function() {
      var t = this,
        i = $("".concat(this.prefix, " #add-to-cart-button-").concat(this.productJSON.id));
      i.closest("form").on("variant-changed", (function(e, s, a, r) {
        +s == +t.productJSON.id && (r && a.available ? (i.attr("disabled", null), i.text(i.data("copy-add"))) : (i.attr("disabled", ""), i.text(i.data(r ? "copy-stock" : "copy-select"))))
      }))
    },
    initImages: function() {
      var t = this,
        i = $("".concat(this.prefix, ' form[data-product-id="').concat(this.productJSON.id, '"]')),
        e = i.find(".product-images");
      i.on("variant-changed", (function(i, s, a, r) {
        +s == +t.productJSON.id && e.find('[data-color="'.concat(a.option1, '"]')).first().removeClass("hide").siblings().addClass("hide")
      }))
    },
    destroy: function() {
      this.undelegateEvents()
    }
  });
window.AddToCart = {
  init: function(t) {
    return new AddToCartView(t)
  }
};